import React, { Component } from "react";
import { injectIntl } from "react-intl";
import _debounce from "lodash/debounce";
import { Grid } from "@material-ui/core";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, TextInput, PublishedComponent, ControlledField } from "@openimis/fe-core";
import StatusPicker from "../pickers/StatusPicker";

const styles = (theme) => ({
    form: {
        padding: 0,
    },
    item: {
        padding: theme.spacing(1),
    },
});

class ProjectsFilter extends Component {
    constructor(props) {
        super(props);
        this.state = { reset: 0 };
        this.debouncedHandleInputChange = _debounce(this._handleInputChange, 300);
    }

    componentWillUnmount() {
        this.debouncedHandleInputChange.cancel();
    }

    _filterValue = (key) => this.props.filters?.[key]?.value ?? null;

    _createFilter = (key, value) => {
        if (!value) return null;
        if (key === "status") return `${key}: ${parseInt(value, 10)}`;
        if (key === "createdDate") return `${key}: "${new Date(value).toISOString().split('T')[0]}"`;
        return `${key}_Icontains: "${String(value).replace(/"/g, '\\"')}"`;
    };

    _handleInputChange = (key, value) => {
        if (!this.props.onChangeFilters) return;
        this.props.onChangeFilters([{ id: key, value, filter: this._createFilter(key, value) }].slice(0, 1));
    };

    _onInputChange = (key, value) => this.debouncedHandleInputChange(key, value);

    _onChangeHealthFacility = (value) => {
        if (this.props.onChangeFilters) {
            this.props.onChangeFilters([
                { id: "healthFacility", value, filter: value ? `healthFacility: "${value}"` : null },
                { id: "claimAdmin", value: null, filter: null },
                { id: "claimBatchRun", value: null, filter: null },
            ].slice(0, 1));
        }
        this.setState((prevState) => ({ reset: prevState.reset + 1 }));
        this.props.selectHealthFacility?.(value);
    };

    render() {
        const { classes } = this.props;
        return (
            <Grid container className={classes.form}>
                <ControlledField
                    module="quality_assurance_and_accreditation"
                    id="quality_assurance_and_accreditation.project.Hf"
                    field={
                        <Grid item xs={3} className={classes.item}>
                            <PublishedComponent
                                pubRef="location.HealthFacilityPicker"
                                value={this._filterValue("healthFacility")}
                                reset={this.state.reset}
                                onChange={this._onChangeHealthFacility}
                            />
                        </Grid>
                    }
                />
                <Grid item xs={4} className={classes.item}>
                    <TextInput
                        label="Accreditation Name"
                        name="projectName"
                        value={this._filterValue("projectName") || ""}
                        onChange={(v) => this._onInputChange("projectName", v)}
                    />
                </Grid>
                <Grid item xs={4} className={classes.item}>
                    <StatusPicker
                        value={this._filterValue("status") || ""}
                        onChange={(v) => this._onInputChange("status", v)}
                    />
                </Grid>
                <ControlledField
                    module="quality_assurance_and_accreditation"
                    id="quality_assurance_and_accreditation.dateCreated"
                    field={
                        <Grid item xs={4} className={classes.item}>
                            <PublishedComponent
                                pubRef="core.DatePicker"
                                value={this._filterValue("createdDate")}
                                module="quality_assurance_and_accreditation"
                                label="project.createdDate"
                                onChange={(d) => this._onInputChange("createdDate", d ? new Date(d).toISOString().split('T')[0] : null)}
                            />
                        </Grid>
                    }
                />
            </Grid>
        );
    }
}

export default withModulesManager(injectIntl(withTheme(withStyles(styles)(ProjectsFilter))));
